export default {
  data() {
    return {
      // 表格示例
      // columns: [
      //   {
      //     title: '列标题', // 基本数据
      //     title1: '列标题', // 如果自定义了title就需要加一个title1用来显示筛选名称
      //     cantCheck: true, // 为true不能隐藏
      //     show: undefined, // 无值和true都显示
      //     // ...其他配置信息
      //   }
      // ]
    };
  },
  computed: {
    filteredColumns() {
      if(this.columns) {
        return this.columns.filter(column => {
          return column.show === undefined || column.show === true;
        })
      } else {
        return [];
      }
    },
  }
};




// WEBPACK FOOTER //
// ./src/libs/mixin.js